module.exports = __webpack_public_path__ + "static/media/camera-lens.3e59ce09.png";